import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
export default {
  name: "faceteach-true-false",
  props: {
    isBook: {
      type: Boolean,
      default: true
    },
    queTitle: {
      type: String,
      default: ""
    },
    queFaceId: {
      type: String,
      default: ""
    },
    questionnaireId: {
      type: String,
      default: ""
    },
    queId: {
      type: String,
      default: ""
    },
    quesType: {
      type: Number,
      default: 3
    },
    quesOrder: {
      type: Number,
      default: 1
    },
    courseId: {
      type: String,
      default: ""
    },
    courseOpenId: {
      type: String,
      default: ""
    },
    iSubmit: {
      type: Boolean,
      default: false
    },
    isquestion: {
      type: Boolean,
      default: true
    },
    li: {
      type: Object,
      default: {
        questionId: "",
        ContentText: "",
        dataJson: [{
          Content: "正确"
        }, {
          Content: "错误"
        }],
        questionType: 3,
        sortOrder: 1
      }
    }
  },
  data: function data() {
    return {
      thisTitle: "",
      isShow: false
    };
  },
  watch: {
    iSubmit: function iSubmit(val) {
      if (val) {
        this.checkSubmit();
      }
    },
    queTitle: function queTitle(val) {
      this.thisTitle = this.queTitle;
    }
  },
  methods: {
    saveQuestion: function saveQuestion(type) {
      var title = this.queTitle;
      var dataJson = [{
        Content: "正确",
        SortOrder: 0
      }, {
        Content: "错误",
        SortOrder: 1
      }];

      if (this.quesType == 4) {
        dataJson = [{
          Content: "赞成",
          SortOrder: 0
        }, {
          Content: "反对",
          SortOrder: 1
        }];
      }

      var stringJson = JSON.stringify(dataJson);
      var activityId = this.queFaceId;
      var questionnaireId = this.questionnaireId;
      var questionId = this.queId;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/addQuestionnaireDetail", {
        questionnaireId: questionnaireId,
        questionId: questionId,
        title: title,
        dataJson: stringJson,
        answer: "",
        questionType: this.quesType,
        sortOrder: this.quesOrder
      }).then(function (rst) {
        if (rst.code > 0) {
          if (type == 1) {
            that.$emit("done", {
              code: 1
            });
          } else {
            that.$emit("updatePage", {});
            that.$message(rst.msg);
          }
        } else {
          that.$message(rst.msg);
        }
      });
    },
    saveCourseQuest: function saveCourseQuest() {
      var dataJson = [{
        Content: "正确",
        SortOrder: 0
      }, {
        Content: "错误",
        SortOrder: 1
      }];

      if (this.quesType == 4) {
        dataJson = [{
          Content: "赞成",
          SortOrder: 0
        }, {
          Content: "反对",
          SortOrder: 1
        }];
      }

      var questionnaireId = this.questionnaireId;
      var questionId = this.queId;
      var title = this.queTitle;
      var stringJson = JSON.stringify(this.dataJson);
      var questionType = this.quesType;
      var that = this;
      this.$http.post("/api/XOrg/BookMaterial/saveCourseQuest", {
        courseId: that.courseId,
        courseOpenId: that.courseOpenId,
        questionnaireId: questionnaireId,
        questionId: questionId,
        title: title,
        dataJson: stringJson,
        answer: "",
        questionType: questionType
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$emit("updatePage", {});
        }

        that.$message(rst.msg);
      });
    },
    save: function save() {
      if (this.queFaceId == "" || this.queFaceId == null) {
        this.saveCourseQuest();
      } else {
        this.saveQuestion(2);
      }
    },
    checkSubmit: function checkSubmit() {
      if (this.li.ContentText == "") {
        this.$emit("submit", {
          code: 0,
          count: 1,
          msg: "第" + this.li.sortOrder + "题标题为空"
        });
        return;
      }

      this.$emit("submit", {
        code: 1,
        count: 1,
        msg: "success"
      });
    }
  },
  created: function created() {
    this.thisTitle = this.queTitle;
  },
  mounted: function mounted() {
    var path = this.$route.path;

    if (path.indexOf("ShareSurveyCourseView") != -1) {
      this.isShow = true;
    }
  }
};